export class Prediction {
    constructor(public id?: number,
                public invoiceId?: string,
                public invoiceOcr?: string,
                public lastModified?: string | Date,
                public iceExtractorStatus?: string,
                public iceSupplierPredictedByIceExtractor?: string,
                public fiscalIdPredictedByExtractor?: string,
                public deskewingInvoiceStatus?: string,
                public supplierTaxIdPredictedByExtractor?: string,
                public milouBlockStatus?: string,
                public voterStatus?: string,
                public processed?: string,
                public invoiceStatus?: string,
                public imageUrl?: string,
                public fileName?: string
    ) {
    }
}
